// Mobilní patička — akordeony odkazových sloupců (screens/m02-footer.md §4,
// mockup design/FooterMobil.dc.html).
//
// Akordeon dostávají JEN tři čistě odkazové sloupce (`.bs-footer-col--links`).
// Zákaznický servis a newsletter zůstávají trvale otevřené — telefon, e-mail
// a přihlášení k odběru jsou jediné konverzní akce patičky (rozhodnutí specky).
//
// Sbalení řeší CSS třída `js-footer-collapsible`, kterou přidáváme až tady:
// bez JS (a pro roboty) zůstanou všechny odkazy vypsané. Nad $bp-md je akordeon
// neaktivní — hlavička se chová jako obyčejný nadpis (CSS schová chevron,
// handler nic nedělá) a `aria-expanded` hlásí trvale otevřený stav.
//
// Idempotentní; běží až po siteFooter.js (staví sloupce, na které se váže).

import { icon } from './icon.js';

const MQ = '(max-width: 768px)';

let cols = [];
let mq = null;

function isMobile() {
  return !!mq && mq.matches;
}

// Na desktopu je obsah vždy vidět → `aria-expanded` musí být true, ať čtečka
// nehlásí sbalený blok tam, kde jsou odkazy na očích.
function syncCol(col) {
  const btn = col.querySelector('.bs-footer-acc');
  if (!btn) return;
  const mobile = isMobile();
  const open = mobile ? col.classList.contains('is-open') : true;
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (mobile) btn.removeAttribute('aria-disabled');
  else btn.setAttribute('aria-disabled', 'true');
}

function syncAll() {
  for (const col of cols) syncCol(col);
}

// Nezávislé akordeony jsou single-open: otevření jednoho zavře předchozí,
// aby patička na mobilu zůstala krátká.
function toggle(col) {
  if (!isMobile()) return;
  const open = col.classList.contains('is-open');
  for (const other of cols) other.classList.remove('is-open');
  if (!open) col.classList.add('is-open');
  syncAll();
}

function decorate(col, index) {
  const title = col.querySelector('.bs-footer-col__title');
  const links = col.querySelector('.bs-footer-col__links');
  if (!title || !links || title.querySelector('.bs-footer-acc')) return false;

  const id = 'bs-footer-acc-' + index;
  links.id = id;

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'bs-footer-acc';
  btn.setAttribute('aria-controls', id);

  const label = document.createElement('span');
  label.className = 'bs-footer-acc__label';
  label.textContent = title.textContent;
  btn.appendChild(label);
  btn.appendChild(icon('chevron-down', 'bs-footer-acc__chev'));

  title.textContent = '';
  title.appendChild(btn);

  btn.addEventListener('click', function () {
    toggle(col);
  });

  // Až teď smí CSS sloupec sbalit (bez JS zůstanou odkazy vypsané).
  col.classList.add('js-footer-collapsible');
  return true;
}

export function initFooterAccordion() {
  const footer = document.getElementById('footer');
  if (!footer || footer.dataset.bsAccordion) return;
  const found = [...footer.querySelectorAll('.bs-footer-col--links')];
  if (!found.length) return;
  footer.dataset.bsAccordion = '1';

  cols = found.filter(function (col, i) {
    return decorate(col, i + 1);
  });
  if (!cols.length) return;

  mq = window.matchMedia(MQ);
  // Safari < 14 nezná addEventListener na MediaQueryList.
  if (mq.addEventListener) mq.addEventListener('change', syncAll);
  else if (mq.addListener) mq.addListener(syncAll);

  syncAll();
}
